import currency from "currency.js";
import { useCallback } from "react";
import moment from "moment";
import { getOptionAssets, getVaultChain, } from "../constants/constants";
import { useLatestOption } from "../hooks/useLatestOption";
import useLoadingText from "../hooks/useLoadingText";
import { formatOptionStrike } from "../utils/math";
import { useAssetsPrice } from "./useAssetPrice";
var useStrikePrice = function (vaultOption, vaultVersion) {
    var loadingText = useLoadingText();
    var _a = useLatestOption(vaultOption, vaultVersion), currentOption = _a.option, optionLoading = _a.loading;
    var _b = useAssetsPrice(), prices = _b.prices, priceLoading = _b.loading;
    var optionAsset = getOptionAssets(vaultOption);
    var strikePrice = useCallback(function (formatted) {
        if (formatted === void 0) { formatted = true; }
        var chain = getVaultChain(vaultOption);
        // console.group('strikePrice');
        // console.log(chain);
        // console.log(optionLoading);
        // console.log(currentOption);
        // console.log(formatted);
        // console.groupEnd();
        // console.log('optionLoading:', optionLoading)
        // if (optionLoading) return loadingText;
        if (!currentOption)
            return "---";
        // console.log("currentOption>", currentOption)
        if (formatted) {
            return currency(formatOptionStrike(currentOption.strike, chain), { precision: 0 }).format();
        }
        else {
            // console.log("formatOptionStrike:", formatOptionStrike(currentOption.strike, chain));
            return formatOptionStrike(currentOption.strike, chain);
        }
    }, [currentOption, loadingText, optionLoading, vaultOption]);
    var currentPrice = useCallback(function (formatted) {
        if (formatted === void 0) { formatted = true; }
        if (priceLoading)
            return loadingText;
        if (formatted) {
            return currency(prices[optionAsset]).format();
        }
        else {
            return Number(prices[optionAsset].toFixed(2));
        }
    }, [priceLoading, loadingText, optionAsset, prices]);
    var expiry = useCallback(function (formatted) {
        if (formatted === void 0) { formatted = true; }
        if (!currentOption)
            return loadingText;
        return moment(currentOption.expiry, "X").utc().format("DD-MMM-YY h:mm a").toUpperCase() + ' UTC';
    }, [loadingText, currentOption]);
    return {
        expiry: expiry,
        strikePrice: strikePrice,
        currentPrice: currentPrice,
        isLoading: optionLoading || priceLoading,
    };
};
export default useStrikePrice;
//# sourceMappingURL=useStrikePrice.js.map